import _defineProperty from "/var/jenkins_home/workspace/tingle.caa77636-11e8-4573-9fa8-b0d26a83c900/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/var/jenkins_home/workspace/tingle.caa77636-11e8-4573-9fa8-b0d26a83c900/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { ThemeProvider } from 'styled-components';
import { useSwipeable } from 'react-swipeable';
import { IconChevronLeft, IconChevronRight } from '@spotify-internal/encore-web';
import { useTracking } from '../../Tracking';
import { MODULE_THEMES, defaultTheme } from '../../Theme';
import { getTallest, setTallestClass } from '../../utils';
import { Carousel, Slides, Slide, Dots, Dot, NextArrow, PreviousArrow, Splash } from './ModuleCarousel.styles';
import { useT, useLocale } from '@mrkt/features/i18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var CAROUSEL_AUTO_ROTATE_MS = 7000;
export var TRANSLATED_MODULE_TYPES = new Set(['headerModule']);
export var ModuleCarousel = /*#__PURE__*/React.forwardRef(function (_ref, _) {
  var _slides$curIndex, _slides$curIndex2;

  var _ref$carouselSlides = _ref.carouselSlides,
      carouselSlides = _ref$carouselSlides === void 0 ? [] : _ref$carouselSlides,
      _ref$onShowSlide = _ref.onShowSlide,
      onShowSlide = _ref$onShowSlide === void 0 ? function () {} : _ref$onShowSlide,
      _ref$showDots = _ref.showDots,
      showDots = _ref$showDots === void 0 ? true : _ref$showDots,
      _ref$doAutoRotate = _ref.doAutoRotate,
      doAutoRotate = _ref$doAutoRotate === void 0 ? true : _ref$doAutoRotate,
      isHeader = _ref.isHeader,
      _ref$isVisible = _ref.isVisible,
      isVisible = _ref$isVisible === void 0 ? false : _ref$isVisible,
      _ref$contentType = _ref.contentType,
      contentType = _ref$contentType === void 0 ? 'moduleCarousel' : _ref$contentType,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Unknown' : _ref$title,
      _ref$startIndex = _ref.startIndex,
      startIndex = _ref$startIndex === void 0 ? 0 : _ref$startIndex,
      Module = _ref.Module;
  var t = useT();
  var locale = useLocale();

  var _useTracking = useTracking(),
      sendEvent = _useTracking.sendEvent;

  var _React$useState = React.useState(startIndex),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      activeIndex = _React$useState2[0],
      setActiveIndex = _React$useState2[1];

  var curIndex = activeIndex;
  var autoRotate = React.useRef(doAutoRotate);
  var autoRotateInterval = React.useRef(null);
  var slides = carouselSlides.filter(function (s) {
    return Boolean(s && s.contentType && (!TRANSLATED_MODULE_TYPES.has(s.contentType) || locale === 'en' || s.translated));
  });
  var viewed = React.useRef({});

  var _React$useState3 = React.useState(1),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      tallest = _React$useState4[0],
      setTallest = _React$useState4[1];

  var _React$useState5 = React.useState(1),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      width = _React$useState6[0],
      setWidth = _React$useState6[1];

  function jumpToSlide(index) {
    setActiveIndex(index);
    stopAutoRotate();
  }

  var nextIndex = function nextIndex(i) {
    return i + 1 >= slides.length ? 0 : i + 1;
  };

  var prevIndex = function prevIndex(i) {
    return i - 1 >= 0 ? i - 1 : slides.length - 1;
  };

  function startAutoRotate() {
    autoRotate.current = true;

    if (!autoRotateInterval.current) {
      autoRotateInterval.current = setInterval(function () {
        setActiveIndex(nextIndex);
      }, CAROUSEL_AUTO_ROTATE_MS);
    }
  }

  function stopAutoRotate() {
    autoRotate.current = false;

    if (autoRotateInterval.current) {
      clearInterval(autoRotateInterval.current);
      autoRotateInterval.current = null;
    }
  }

  var fireEvent = React.useCallback(function (action) {
    var label = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : title;
    sendEvent({
      eventCategory: "Frodor - module-".concat(contentType),
      eventAction: action,
      eventLabel: label
    });
  }, [title]);
  var swipeHandlers = useSwipeable({
    onSwipedLeft: function onSwipedLeft() {
      fireEvent('swipe');
      jumpToSlide(nextIndex);
    },
    onSwipedRight: function onSwipedRight() {
      fireEvent('swipe');
      jumpToSlide(prevIndex);
    },
    preventDefaultTouchmoveEvent: true,
    trackMouse: false,
    trackTouch: true
  });
  React.useEffect(function () {
    if (doAutoRotate && isVisible) {
      startAutoRotate();
    } else {
      stopAutoRotate();
    }

    return function () {
      stopAutoRotate();
    };
  }, [doAutoRotate, isVisible]);
  React.useEffect(function () {
    var curSlide = slides[curIndex];

    if (!viewed.current[curIndex]) {
      // fire event if slide not viewed before
      viewed.current[curIndex] = true;
      fireEvent('view-slide', "".concat(title, " - ").concat((curSlide === null || curSlide === void 0 ? void 0 : curSlide.title) || 'Unknown'));
    }

    onShowSlide === null || onShowSlide === void 0 ? void 0 : onShowSlide(curSlide, curIndex);
  }, [activeIndex]);
  React.useEffect(function () {
    onShowSlide === null || onShowSlide === void 0 ? void 0 : onShowSlide(slides[curIndex], curIndex);
  }, [activeIndex]);
  var moduleRefs = [];

  var getModuleWithRef = function getModuleWithRef(mod, index) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    moduleRefs[index] = React.useRef();
    return /*#__PURE__*/_jsx(Module, _objectSpread(_objectSpread({}, mod), {}, {
      ref: moduleRefs[index]
    }));
  };

  React.useEffect(function () {
    var handleResize = function handleResize() {
      setWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return function cleanupListener() {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  React.useEffect(function () {
    setTallest(getTallest(moduleRefs));
    setTallestClass(moduleRefs);
  }, [getTallest(moduleRefs), width]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Splash, {
      tallest: tallest
    }), /*#__PURE__*/_jsxs(Carousel, _objectSpread(_objectSpread({
      isHeader: isHeader
    }, swipeHandlers), {}, {
      tallest: tallest,
      children: [/*#__PURE__*/_jsx(Slides, {
        children: slides.map(function (mod, index) {
          return /*#__PURE__*/_jsx(ThemeProvider, {
            theme: _objectSpread(_objectSpread({}, defaultTheme), MODULE_THEMES[mod.themeName || '']),
            children: /*#__PURE__*/_jsx(Slide, {
              active: curIndex === index,
              "data-testid": "slide",
              children: getModuleWithRef(mod, index)
            })
          }, "module-carousel-slide-".concat(index));
        })
      }), showDots && /*#__PURE__*/_jsx(Dots, {
        children: slides.map(function (_, index) {
          return /*#__PURE__*/_jsx(Dot, {
            active: curIndex === index,
            onClick: function onClick() {
              fireEvent('click', 'Dots');
              jumpToSlide(index);
            },
            color: slides[curIndex].backgroundColor,
            "aria-label": "".concat(t('FRODOR_GO_TO_SLIDE_NUM_MODULE_CAROUSEL', 'Go to slide number {slideNum}', 'Slide in this case means a slide in a slideshow', {
              slideNum: index + 1
            }))
          }, "dot-".concat(index));
        })
      }), /*#__PURE__*/_jsx(PreviousArrow, {
        onClick: function onClick() {
          fireEvent('click', 'Arrow');
          jumpToSlide(prevIndex);
        },
        color: (_slides$curIndex = slides[curIndex]) === null || _slides$curIndex === void 0 ? void 0 : _slides$curIndex.backgroundColor,
        "aria-label": t('FRODOR_GO_TO_PREV_SLIDE_MODULE_CAROUSEL', 'Go to previous slide', 'Slide in this case means a slide in a slideshow'),
        children: /*#__PURE__*/_jsx(IconChevronLeft, {
          iconSize: 32
        })
      }), /*#__PURE__*/_jsx(NextArrow, {
        onClick: function onClick() {
          fireEvent('click', 'Arrow');
          jumpToSlide(nextIndex);
        },
        color: (_slides$curIndex2 = slides[curIndex]) === null || _slides$curIndex2 === void 0 ? void 0 : _slides$curIndex2.backgroundColor,
        "aria-label": t('FRODOR_GO_TO_NEXT_SLIDE_MODULE_CAROUSEL', 'Go to next slide', 'Slide in this case means a slide in a slideshow'),
        children: /*#__PURE__*/_jsx(IconChevronRight, {
          iconSize: 32
        })
      })]
    }))]
  });
});